<script lang="ts">
  import { setModalHash } from '../shared/modal-store';
  import { onMount } from 'svelte';
  import Button from '../shared/button.svelte';
  import Footer from '../shared/footer.svelte';
  import Grid from '../shared/grid.svelte';
  import AnimatedSquares from '../components/home/animated-squares.svelte';
  import { setHeaderColor } from '../shared/header-store';

  let slide = 0;

  onMount(() => {
    setHeaderColor('uniapp', 'uniapp', '/shared-example');
  });

  function setModalComponent(app) {
    setModalHash(app);
  }
</script>

<main class="flex flex-col justify-between h-100 pt-[104px] bg-gray">
  <p>
    <button
      on:click={() => {
        setHeaderColor('black', 'gray', '/shared-example');
      }}>black nav</button
    >
    <button
      on:click={() => {
        setHeaderColor('white', 'gray', '/shared-example');
      }}>white nav</button
    >
    <button
      on:click={() => {
        setHeaderColor('red', 'gray', '/shared-example');
      }}>red nav</button
    >
    <button
      on:click={() => {
        setHeaderColor('orange', 'gray', '/shared-example');
      }}>orange nav</button
    >
    <!-- svelte-ignore a11y-missing-attribute -->
    <a on:click={() => setModalComponent('wellabe')}>wellabe modal</a>
    <!-- svelte-ignore a11y-missing-attribute -->
    <a on:click={() => setModalComponent('uniapp')}>uniapp modal</a>
  </p>
  <Grid>
    <div class="col-span-4">
      <img alt="contact" src="images/contact-illustration.png" />
    </div>
    <div class="col-span-6">
      <Button label="Our work" />
      <h1>We’re always looking for new great talent. Checkout current openings.</h1>
      <p>
        The app has been downloaded over 90k times in the 3 years with a consistent user base of 75k
        people per year.
      </p>
      <p>
        The mobile app should be fast to develop, easy to maintain and potentially be open-source.
        So we chose Ionic + Angular to build the web and mobile apps.
      </p>
    </div>
  </Grid>
  <button on:click={() => (slide = slide - 1)} disabled={slide === 0}>slide -</button>
  <button on:click={() => (slide = slide + 1)} disabled={slide === 5}>slide +</button>
  <AnimatedSquares {slide} />
  <Footer />
</main>
